// BurgerMenu.js
import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import './BurgerMenu.css'; // Importez votre fichier CSS pour le style

const BurgerMenu = () => {
  const tabs = ["Accueil", "BDtheque"];

  return (
    <Menu>
      {tabs.map((tab) => (
        <a className="menu-item" href={tab}>
          {tab}
        </a>
      ))}
    </Menu>
  );
};

export default BurgerMenu;
